import requests from './httpService';
const SuperActivityTabelService = {
  getAllSuperActivity(id) {
    return requests.get(`/superactivity/list/${id}`);
  },
  getStudentSuperActivity(id) {
    return requests.get(`/superactivity/list/${id}`);
  },
  getAllSuperActivityById(id,body){
    return requests.post(`/superactivity/list/${id}`,body); 
  },
//   upadeCity(body) {
//     return requests.put(`/city/${body.id}`,body); 
//   },
  creteSuperActivity(body){
    return requests.post('/superactivity/add',body); 
  },
//   getAllSuperActivityTabelMultiple(body) {
//   return requests.get(`/superactivity/list/multiple/${classId}`, body);
// },
getAllSuperActivityTabelMultiple( body) {
  return requests.post(`/superactivity/multiple`, body);
},

  // getAllSuperActivityTabelMultiple(id) {
  //   return requests.get(`/superactivity/list/multiple/${id}`);
  // },
  deleteSuperActivity(body){
    return requests.delete(`/superactivity/${body._id}`); 
  },
//   getAllCoupon() {
//     return requests.get('/coupon');
//   },
// getAllAddClass() {
//   return requests.get('/addclass');
// },
  upadeSuperActivity(body) {
    return requests.put(`/superactivity/${body._id}`,body); 
  },
//   creteCoupon(body){
//     return requests.post('/coupon/add',body); 
//   },
//   deleteCoupon(body){
//     return requests.delete(`/coupon/${body._id}`); 
//   },
//   createVendorOrdersById(body){
//     return requests.post('/orders/getvendororders',body); 
//   },

//   getAllVendorList() {
//     return requests.get('/vendorlist');
//   },

};

export default SuperActivityTabelService;
